import { createSelector } from '@reduxjs/toolkit';
const selectOnboarding = (state) => state.onboardingV2;
export const selectName = createSelector([selectOnboarding], (onboardingV2) => onboardingV2.name);
